import React from "react";
import { LegalLayout, LegalBlock } from "@/components/LegalLayout";
import { COMPANY } from "@/data/site";

export default function Datenschutz() {
  return (
    <LegalLayout
      title="Datenschutzerklärung"
      subtitle="Informationen zum Umgang mit Ihren personenbezogenen Daten"
      testId="datenschutz-page"
    >
      <LegalBlock heading="1. Datenschutz auf einen Blick">
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was
          mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website
          besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
          persönlich identifiziert werden können.
        </p>
      </LegalBlock>

      <LegalBlock heading="2. Verantwortliche Stelle">
        <p>Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
        <p className="mt-2 font-semibold text-neutral-900">{COMPANY.name}</p>
        <p>{COMPANY.street}</p>
        <p>{COMPANY.city}</p>
        <p>
          Telefon:{" "}
          <a href={`tel:${COMPANY.phoneTel}`} className="text-[var(--kilic-blue)]">
            {COMPANY.phoneDisplay}
          </a>
        </p>
        <p>
          E-Mail:{" "}
          <a href={`mailto:${COMPANY.email}`} className="text-[var(--kilic-blue)]">
            {COMPANY.email}
          </a>
        </p>
      </LegalBlock>

      <LegalBlock heading="3. Kontaktaufnahme via WhatsApp">
        <p>
          Über das Anfrageformular auf dieser Website wird eine vorausgefüllte
          Nachricht erstellt, die Sie über den Dienst WhatsApp an uns senden
          können. Ihre Daten werden dabei nicht auf dieser Website gespeichert,
          sondern direkt über WhatsApp an uns übermittelt. Für die Verarbeitung
          Ihrer Daten durch WhatsApp gilt die Datenschutzerklärung der WhatsApp
          Ireland Limited. Bitte beachten Sie, dass die Kommunikation über
          WhatsApp außerhalb unseres Einflussbereichs erfolgt.
        </p>
        <p>
          Rechtsgrundlage für die Verarbeitung ist Art. 6 Abs. 1 lit. a und b
          DSGVO (Einwilligung sowie Anbahnung / Erfüllung eines Vertrags).
        </p>
      </LegalBlock>

      <LegalBlock heading="4. Server-Log-Dateien">
        <p>
          Der Provider der Seiten erhebt und speichert automatisch Informationen
          in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns
          übermittelt (Browsertyp, Betriebssystem, Referrer-URL, Hostname,
          Uhrzeit der Serveranfrage, IP-Adresse). Diese Daten werden nicht mit
          anderen Datenquellen zusammengeführt. Rechtsgrundlage ist Art. 6 Abs.
          1 lit. f DSGVO.
        </p>
      </LegalBlock>

      <LegalBlock heading="5. Google Maps">
        <p>
          Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die
          Google Ireland Limited. Zur Nutzung der Funktionen von Google Maps ist
          es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen werden
          in der Regel an einen Server von Google in den USA übertragen und dort
          gespeichert. Die Nutzung erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
          f DSGVO.
        </p>
      </LegalBlock>

      <LegalBlock heading="6. Ihre Rechte">
        <p>Sie haben jederzeit das Recht:</p>
        <ul className="ml-5 list-disc space-y-1">
          <li>Auskunft über Ihre gespeicherten Daten zu erhalten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
          <li>die Verarbeitung einschränken zu lassen (Art. 18 DSGVO)</li>
          <li>der Verarbeitung zu widersprechen (Art. 21 DSGVO)</li>
          <li>Datenübertragbarkeit zu verlangen (Art. 20 DSGVO)</li>
        </ul>
        <p>
          Zudem steht Ihnen ein Beschwerderecht bei einer
          Datenschutz-Aufsichtsbehörde zu.
        </p>
      </LegalBlock>

      <LegalBlock heading="7. SSL- bzw. TLS-Verschlüsselung">
        <p>
          Diese Seite nutzt aus Sicherheitsgründen eine SSL- bzw.
          TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie
          daran, dass die Adresszeile des Browsers von „http://“ auf „https://“
          wechselt.
        </p>
      </LegalBlock>
    </LegalLayout>
  );
}
